import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

/**
 * Small outlined chip that applies a suggested value when clicked. Once the
 * suggestion has been used the consumer disables it, dimming the chip.
 */
@Component({
  selector: 'app-suggestion-chip',
  templateUrl: './suggestion-chip.component.html',
  styleUrls: ['./suggestion-chip.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
})
export class SuggestionChipComponent {
  readonly label = input.required<string>();
  readonly icon = input('add');
  readonly disabled = input(false);

  readonly selected = output();
}
